import LogoIcon from "../assets/icons/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import clsx from "clsx";
import { ReactComponent as LogoutIcon } from "../assets/icons/logout.svg";
import { ReactComponent as SideBarHue } from "../assets/icons/sidebar-hue.svg";

import { clearTokenAndUser } from "../helpers/utils";
import { Button } from "./Button";

export default function Sidebar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearTokenAndUser();
    localStorage.clear();
    navigate("/login");
  };

  // Desktop Sidebar
  return (
    <div className="lg:flex flex-col h-[100dvh] relative hidden min-w-[300px] p-3 border-r border-[#C2D3C9]">
      <img
        src="/images/menu-bg.svg"
        alt="menu-bg"
        className="absolute top-0 left-0 w-full"
      />
      <div className="mb-4 px-4 py-5 z-[1]">
        <Link
          to="/home"
          className="flex font-outfit font-[500] text-[1.125rem] items-center gap-1"
        >
          <img src={LogoIcon} alt="logo" className="h-[24px] w-[129px]" />
        </Link>
      </div>

      <div className="grid gap-[0.375rem] z-[1]">
        <CustomLink to="/dashboard" activePath="/dashboard" label="Dashboard" />
        <CustomLink to="/users" activePath="/users" label="Manage users" />
        <CustomLink to="/banners" activePath="/banners" label="Banners" />
        <CustomLink
          to="/service-types"
          activePath="/service-types"
          label="Manage service types"
        />

        {/* <CustomLink
          to="/institutions"
          activePath="/institutions"
          label="Institution and schools"
        /> */}

        <button
          onClick={handleLogout}
          className="absolute bottom-3 hover:opacity-80 cursor-pointer w-[calc(100%-24px)] p-3 rounded-lg flex flex-row items-center gap-2"
        >
          <LogoutIcon width={24} height={24} />
          <span className="text-[#5B5B5B] font-medium text-base">Logout</span>
        </button>
      </div>
    </div>
  );
}

function CustomLink({
  to,
  activePath,
  label,
}: {
  to: string;
  activePath: string;
  label: string;
}) {
  const isActive = window.location.pathname === activePath;

  return (
    <Link to={to}>
      <Button
        className={clsx(
          "!px-[1.375rem] !rounded-md py-3 border-0 hover:!bg-[#A1CE99] flex flex-row !justify-start gap-2 w-full items-center",
          {
            "!bg-[#A1CE99] shadow-[0px_1px_4px_0px_rgba(100,182,103,0.11)]":
              isActive,
          }
        )}
        variant={isActive ? "primary" : "outline"}
      >
        <span
          className={clsx(
            { "!text-[#666]": !isActive },
            "text-black font-[500] text-[1rem]"
          )}
        >
          {label}
        </span>
      </Button>
    </Link>
  );
}
